import { http } from './http'
// 获取当前活动状态
export const getConfigsOperationalActivities = () => {
  // console.log("调用了 emm");
  // return {
  //   status: "ok",
  //   err_msg: "",
  //   data: {
  //     vip_new_year_promotion: {
  //       use_config: false,
  //       desc: "包年会员新春促销赠送3个月会员+8折折扣码",
  //       start_at: "2026-02-02 00:00:00",
  //       expired_at: new Date(Date.now() + 1 * 10 * 1000).toISOString(), // 当前时间延后1分钟
  //     },
  //   },
  // };
  return http({
    // baseUrl: baseUrl,
    url: "/api/public/configs/promotion",
    method: "get",
    alert: false,
    // query: params,
  });
};
